// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2e9zQ","actions":"GroupTable_actions__3goI1","deleteModalFooter":"GroupTable_deleteModalFooter__10LJu"};